import { Text, TextSize, Weight, Arrow, Fonts } from 'components'
import { ChartComponent } from 'components/charts/atomic-product-chart'

import styled from 'styled-components'
import { GLOBAL_COLORS } from 'theme'

export const SwitchContentWrapper = styled.div`
  display: flex;
  margin-top: 195px;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 0;
    padding: 30px 40px 30px 40px;
    background-color: ${theme.bg};
    width: fill-available;
  `};
`

export const Title = styled(Text)`
  font-size: ${TextSize.two};
  font-weight: ${Weight.Medium};
`

export const SwitchContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitcherContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  height: 70px;
  background-color: ${({ theme }) => theme.switchBgColor};
  position: absolute;
  top: 460px;
  width: 100%;
  left: 0;
  ${({ theme }) => theme.mediaWidth.Mobile`
    height: auto;
    position: relative;
    top: 0;
    margin-top: 20px;
    justify-content: center;
  `}
`

export const SwitchElements = styled.div`
  max-width: 825px;
  display: flex;
  gap: 60px;
  align-items: center;
  margin: 0 calc(calc(100% - 825px) / 2);
  ${({ theme }) => theme.mediaWidth.Tablet`
    max-width: 680px;
    margin: 0 calc(calc(100% - 680px) / 2);
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    gap: 0;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  `}
`

export const SwitchItem = styled.div`
  transition: 0.4s all;
  cursor: pointer;
  ${({ theme }) => theme.mediaWidth.Mobile`
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    width: fill-available;
    padding: 0 40px;
    border-bottom: 1px solid ${theme.switchTextColor};
  `}
  &:hover {
    opacity: 0.6;
  }
  &:active {
    opacity: 0.2;
  }
`

export const StyledText = styled.span<{ active: boolean }>`
  font-family: ${Fonts.DMSans};
  font-weight: ${Weight.Bold};
  font-size: ${TextSize.four};
  opacity: ${({ active }) => (active ? 1 : 0.4)};
  color: ${({ theme }) => theme.switchTextColor};
  ${({ theme }) => theme.mediaWidth.Mobile`
    height: 40px;
    display: flex;
    align-items: center;
  `}
`

export const StyledArrow = styled(Arrow)`
  border-bottom: 1px solid ${({ theme }) => theme.switchTextColor};
  border-right: 1px solid ${({ theme }) => theme.switchTextColor};
  margin-top: 5px;
  height: 5px;
  width: 5px;
`

export const CustomChartComponent = styled(ChartComponent)`
  ${({ theme }) => theme.mediaWidth.Desktop`
  min-height:350px;
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 20px;
  `};
  box-sizing: border-box;
`

export const BarChartInfoWrapper = styled.div`
  position: relative;
`

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${GLOBAL_COLORS.separatorBg};
  margin: 30px 0;
`
